import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSortMenuList } from '../../../../helpers/sort/SortHelper'
import { TableCell } from '@mui/material'
import MySortHeadField from '../../../UI/table/sort/MySortHeadField'
import { setSupplyBillsSortField, setSupplyBillsSortType } from '../../../../store/supplyBillSlice'

export const CreatedAtSortField = () => {

    const field = useSelector(state => state.supplyBill.supplyBills.sort.field)
    const type = useSelector(state => state.supplyBill.supplyBills.sort.type)
    const dispatch = useDispatch()

    const menuList = getSortMenuList({
        itemsNeeded: ['reset', 'ASC', 'DESC']
    })

  return (
    <TableCell align="center">
        <MySortHeadField
            text={'Дата створення'}
            fieldSlug={'createdAt'}
            field={field}
            setField={e => dispatch(setSupplyBillsSortField(e))}
            type={type}
            setType={e => dispatch(setSupplyBillsSortType(e))}
            menuList={menuList}
        />
    </TableCell>
  )
}
